import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import './EpikBoxes/EpikBoxDetails/BoxPortTabs/EpikBoxObis/BoxObi.css';

const DraggableGroupMembers = ({ move, index, id, value, customClass, type, highlight }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'groupMember',
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      move(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'groupMember',
    item: { type: 'groupMember', id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '10px' }}
    >
      <div className={customClass || 'multi-input-item'} ref={ref} style={{ ...opacity }}>
        <span className="item">{value}</span>
      </div>
      {/* {type === 'interfacePriority' && highlight && <span className="item">Active</span>} */}
    </div>
  );
};

export default DraggableGroupMembers;
